import LogRocket from "logrocket";

const _browserSessionId = (() => Math.random().toString(32))()

LogRocket.init('uiqtcg/fiscalpop-lite');
console.log(`==LOG R INIT == \n(Browser Session: ${_browserSessionId})`)